// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ShareInviteLink__link-c87743 {
  justify-content: flex-start;
  padding: 8px 16px;
  border-radius: 0;
  width: 100%;
  height: initial;
}

.ShareInviteLink__icon-fbcf55 {
  padding: 12px;
  border-radius: 100%;
  margin-inline-end: 12px;
  background-color: var(--addition-50_10);
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/FullScreenCallView/Shared/AnimatedRightPanel/RightPanel/ShareInviteLink/ShareInviteLink.styles.m.css"],"names":[],"mappings":"AAAA;EACE,2BAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uCAAA;AACF","sourcesContent":[".link {\n  justify-content: flex-start;\n  padding: 8px 16px;\n  border-radius: 0;\n  width: 100%;\n  height: initial;\n}\n\n.icon {\n  padding: 12px;\n  border-radius: 100%;\n  margin-inline-end: 12px;\n  background-color: var(--addition-50_10);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": `ShareInviteLink__link-c87743`,
	"icon": `ShareInviteLink__icon-fbcf55`
};
module.exports = ___CSS_LOADER_EXPORT___;
